module.exports = __webpack_public_path__ + "static/media/ig-strip.f0e65614.jpg";